import BuyingFilter from "../../components/filteration/buyingFilter";
import ShopAdds from "../../components/shopAds/ShopAdds";
import Shops from "../../components/Multipleshopprofile/Components/Shops/Shops";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import BackArrow from "../../components/backArrow";
import url from "../../config/axios";
import { ShopContext } from "../../config/shopContext";
import "./buyRestaurantFood.css";

const BuyRestaurantFood = () => {
  const shopType = "foodShop"; // unique context identifier
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [isloading, setIsloading] = useState(false);
  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => setShowshare(true);

  const [dataCategory, setDataCategory] = useState({ categoryid: "" });
  const [shopCategory, setShopCategory] = useState([]);
  const [shopCategorytwo, setShopCategorytwo] = useState([]);
  const [createshopcategory, setCreateshopcategory] = useState([]);

  const [filters, setFilters] = useState(currentData.additionalData || {
    isShop: true,
    shopid: "",
    shopname: "",
    itemname: "",
    marketPlace: "",
    categoryid: "",
    subCategoryid: "",
    shopCategory: "",
    country: "",
    state: "",
    city: "",
    specialoffer: "",
    salespromotion: "",
    min: "",
    max: "",
    sale: "",
    dishname: ""
  });

  // Handle category selection
  const Handledata = (e) => {
    setDataCategory(prev => ({ ...prev, [e.target.name]: e.target.value.split(".") }));
  };

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters(prev => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  // Fetch main and parent categories
  useEffect(() => {
    url.get("category/type/?type=foodShop&parentCategory=")
      .then(res => res?.data?.success && setShopCategory(res.data.data.Category))
      .catch(() => {});

    url.get("category/type/?type=foodShop&parentCategory=true")
      .then(res => res?.data?.success && setCreateshopcategory(res.data.data.Category))
      .catch(() => {});
  }, []);

  // Fetch subcategories based on selected category
  const Mydata = () => {
    url.get(`category/type/?type=foodShopItem&parentCategory=${categoryName}`)
      .then(res => res?.data?.success && setShopCategorytwo(res.data.data.Category))
      .catch(err => console.log(err));
  };

  // Handle filter input changes
  const HandleFilters = (e) => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Automatic voice and query string search handler
  useEffect(() => {
    const executeSearch = (searchTerm) => {
      if (!searchTerm) return;
      setIsloading(true);
      const cleanTerm = searchTerm.trim();
      const updated = {
        ...filters,
        dishname: cleanTerm,
        shopname: cleanTerm,
      };
      setFilters(updated);

      const queryItem = new URLSearchParams({
        businessType: "foodShop",
        filtermethod: "fooditem",
        dishname: cleanTerm,
      }).toString();

      url
        .get(`/fooditem/filter/?${queryItem}`)
        .then((res) => {
          setIsloading(false);
          if (res?.data?.success && (res.data?.FoodItem?.length > 0 || res.data?.Shop?.length > 0)) {
            setShopdata(res.data?.Shop || []);
            setItemmdata(res.data?.FoodItem || []);
            updateFilteredData(shopType, res.data?.Shop || [], res.data?.FoodItem || [], updated);
          } else {
            const queryShop = new URLSearchParams({
              businessType: "foodShop",
              filtermethod: "shop",
              shopname: cleanTerm,
            }).toString();
            url.get(`/fooditem/filter/?${queryShop}`).then((res2) => {
              if (res2?.data?.success) {
                setShopdata(res2.data?.Shop || []);
                setItemmdata(res2.data?.FoodItem || []);
                updateFilteredData(shopType, res2.data?.Shop || [], res2.data?.FoodItem || [], updated);
              }
            });
          }
        })
        .catch(() => setIsloading(false));
    };

    try {
      const params = new URLSearchParams(window.location.search);
      const s = params.get("search");
      if (s) {
        executeSearch(s);
      }
    } catch (e) {}

    const handleVoice = (e) => {
      const q = e?.detail?.query;
      if (q) {
        executeSearch(q);
      }
    };

    window.addEventListener("selectezi:voicesearch", handleVoice);
    return () => {
      window.removeEventListener("selectezi:voicesearch", handleVoice);
    };
  }, [window.location.search]);

  // Build query string
  const buildQuery = (type) => {
    let query = { businessType: "foodShop", filtermethod: type };
    const keys = type === "shop"
      ? ["shopname","shopCategory","marketPlace","shopid","specialoffer","sale"]
      : ["dishname","categoryid","subCategoryid","country","state","city","specialoffer","salespromotion","min","max","isShop"];

    keys.forEach(k => { if(filters[k] && filters[k].trim() !== "") query[k] = filters[k].trim(); });
    return new URLSearchParams(query).toString();
  };

  // Filter by shop
  const FilterHandler = () => {
    setIsloading(true);
    const newFilters = { ...filters, dishname:"", categoryid:"", subCategoryid:"", country:"", state:"", city:"", salespromotion:"", min:"", max:"" };
    setFilters(newFilters);
    setShopdata([]);
    setItemmdata([]);

    const query = buildQuery("shop");
    url.get(`/fooditem/filter/?${query}`)
      .then(res => {
        setIsloading(false);
        if(res?.data?.success){
          setShopdata(res.data?.Shop || []);
          setItemmdata(res.data?.FoodItem || []);
          updateFilteredData(shopType, res.data?.Shop || [], res.data?.FoodItem || [], newFilters);
        }
      })
      .catch(() => setIsloading(false));
  };

  // Filter by food item
  const FilterHandlerItem = () => {
    setIsloading(true);
    const newFilters = { ...filters, shopname:"", shopCategory:"", marketPlace:"", shopid:"", specialoffer:"", sale:"" };
    setFilters(newFilters);
    setShopdata([]);
    setItemmdata([]);

    const query = buildQuery("fooditem");
    url.get(`/fooditem/filter/?${query}`)
      .then(res => {
        setIsloading(false);
        if(res?.data?.success){
          setShopdata(res.data?.Shop || []);
          setItemmdata(res.data?.FoodItem || []);
          updateFilteredData(shopType, res.data?.Shop || [], res.data?.FoodItem || [], newFilters);
        }
      })
      .catch(() => setIsloading(false));
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel showmodal={showmodal} handleClosemodal={handleClosemodal} handleShowshare={handleShowshare} />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="buy-restaurant-food-mobile-back d-lg-none" />
        <Row className="buy-restaurant-food-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <BuyingFilter
                Handleadditioanalshop={HandleFilters}
                FilterHandler={FilterHandler}
                FilterHandleritem={FilterHandlerItem}
                dataCategory={dataCategory}
                createshopcategory={createshopcategory}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                additionalShopCategoryData={filters}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-2 pe-2">
              <BackArrow back="/BuyingSide" mystyle="p-1 ps-1 pt-1 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                link="/food-buying-profile"
                title="Food & Restaurant"
                isloading={isloading}
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
                itemmdata={itemmdata}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BuyRestaurantFood;
